if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();

      this.addToCartButtons = null;
      this.stickyAddToCartButton = null;
      this.stickyOutOfStockButton = null;
      this.mainProductForm = null;
      this.mainAddToCartButton = null;
      this.mainForm = null;

      this.stateObserver = null;
      this.visibilityObserver = null;

      this.onStickyClick = this.onStickyClick.bind(this);
      this.onIntersect = this.onIntersect.bind(this);
      this.onMainButtonMutation = this.onMainButtonMutation.bind(this);

      this.isWired = false;
    }

    connectedCallback() {
      if (this.isWired) return;
      this.isWired = true;

      this.cacheDom();

      if (!this.stickyAddToCartButton && !this.stickyOutOfStockButton) return;

      if (this.stickyAddToCartButton) {
        this.stickyAddToCartButton.addEventListener('click', this.onStickyClick);
      }

      if (this.mainAddToCartButton) {
        this.stateObserver = new MutationObserver(this.onMainButtonMutation);
        this.stateObserver.observe(this.mainAddToCartButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
        this.updateStickyButtonState();
      }

      this.visibilityObserver = new IntersectionObserver(this.onIntersect, {
        threshold: 0,
      });

      const targetButton = this.mainAddToCartButton || this.addToCartButtons?.[0];
      if (targetButton) this.visibilityObserver.observe(targetButton);
    }

    disconnectedCallback() {
      this.stickyAddToCartButton?.removeEventListener('click', this.onStickyClick);

      this.stateObserver?.disconnect();
      this.stateObserver = null;

      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;

      this.isWired = false;
    }

    cacheDom() {
      this.addToCartButtons = document.querySelectorAll(
        '[data-notify-me], [data-out-of-stock], [data-action="add-to-cart"]'
      );

      this.stickyAddToCartButton = this.querySelector('[data-sticky-action="add-to-cart"]');
      this.stickyOutOfStockButton = this.querySelector('[data-sticky-action="out-of-stock"]');

      this.mainProductForm = document.querySelector('[data-section="product-form"] product-form');
      this.mainAddToCartButton = this.mainProductForm?.querySelector('[data-action="add-to-cart"]') || null;
      this.mainForm = this.mainProductForm?.querySelector('form') || null;
    }

    onStickyClick(event) {
      event.preventDefault();

      if (!this.mainAddToCartButton) this.cacheDom();

      if (this.mainAddToCartButton && !this.mainAddToCartButton.hasAttribute('disabled')) {
        this.mainAddToCartButton.click();
      }
    }

    onMainButtonMutation() {
      this.updateStickyButtonState();
    }

    onIntersect([entry]) {
      const gorgiasChatContainer = document.querySelector('#gorgias-chat-container');
      const isPastButton = entry.boundingClientRect.top < 0;

      if (!entry.isIntersecting && isPastButton) {
        this.classList.add('is-visible');
        gorgiasChatContainer?.classList.add('hidden');
      } else {
        this.classList.remove('is-visible');
        gorgiasChatContainer?.classList.remove('hidden');
      }
    }

    updateStickyButtonState() {
      if (!this.mainAddToCartButton) return;

      const isDisabled = this.mainAddToCartButton.hasAttribute('disabled');

      if (isDisabled) {
        this.stickyAddToCartButton?.classList.add('hidden');
        this.stickyOutOfStockButton?.classList.remove('hidden');
      } else {
        this.stickyAddToCartButton?.classList.remove('hidden');
        this.stickyOutOfStockButton?.classList.add('hidden');
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}